<template>
  <d2-container>
    <el-form :model="form" :rules="rules" ref="form" label-width="200px">
      <el-form-item label="作者头像" prop="authorIcon">
        <upload-image v-model="form.authorIcon" :max="1"></upload-image>
      </el-form-item>
      <el-form-item label="作者名称" prop="authorName">
        <el-input v-model="form.authorName" placeholder="请输入作者名称"></el-input>
      </el-form-item>
      <el-form-item label="封面图" prop="cover">
        <upload-image v-model="form.cover" :max="1"></upload-image>
      </el-form-item>
      <el-form-item label="标题" prop="title">
        <el-input v-model="form.title" placeholder="请输入标题"></el-input>
      </el-form-item>
      <el-form-item label="文章内容" prop="content">
        <div class="ql-editor">
          <quill-editor
            ref="myQuillEditor"
            v-model="form.content"
            :options="editorOption"
            @blur="onEditorBlur($event)"
            @focus="onEditorFocus($event)"
            @ready="onEditorReady($event)"
          />
        </div>
      </el-form-item>
      <el-form-item label="开启VIP内容" prop="vipContentEn">
        <el-switch v-model="form.vipContentEn" :active-value="1" active-text="开启" :inactive-value="0" inactive-text="关闭"></el-switch>
      </el-form-item>
      <el-form-item v-if="form.vipContentEn" label="VIP内容" prop="vipContent">
        <div class="ql-editor">
          <quill-editor
            ref="myQuillEditor"
            v-model="form.vipContent"
            :options="editorOption"
            @blur="onEditorBlur($event)"
            @focus="onEditorFocus($event)"
            @ready="onEditorReady($event)"
          />
        </div>
      </el-form-item>
      <el-form-item label="是否热门" prop="isHot">
        <el-select class="filter-item" v-model="form.isHot" placeholder="请选择" @change="selectType">
          <el-option
            v-for="item in isHotList"
            :key="item.index"
            :label="item.name"
            :value="item.index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select
          class="filter-item"
          v-model="form.status"
          placeholder="请选择"
          @change="selectStatus"
        >
          <el-option
            v-for="item in statusList"
            :key="item.index"
            :label="item.name"
            :value="item.index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="点赞数" prop="likeCount">
        <el-input
          v-model="form.likeCount"
          placeholder="请输入点赞数量"
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="footer">
      <el-button @click="cancel('form')">取 消</el-button>
      <el-button type="primary" @click="getCreate('form')">确 定</el-button>
    </div>
  </d2-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { getToken } from '@/api/demo/classification/index'
import {
  addArticle,
  editArticle,
  getArticleDetail
} from '@/api/demo/articleCategory/index'
import { quillEditor, Quill } from 'vue-quill-editor'
import { container, ImageExtend, QuillWatch } from 'quill-image-extend-module'
import UploadImage from '@/components/uploadImage'
// toolbar标题
const titleConfig = [
  { Choice: '.ql-insertMetric', title: '跳转配置' },
  { Choice: '.ql-bold', title: '加粗' },
  { Choice: '.ql-italic', title: '斜体' },
  { Choice: '.ql-underline', title: '下划线' },
  { Choice: '.ql-header', title: '段落格式' },
  { Choice: '.ql-strike', title: '删除线' },
  { Choice: '.ql-blockquote', title: '块引用' },
  { Choice: '.ql-code', title: '插入代码' },
  { Choice: '.ql-code-block', title: '插入代码段' },
  { Choice: '.ql-font', title: '字体' },
  { Choice: '.ql-size', title: '字体大小' },
  { Choice: '.ql-list[value="ordered"]', title: '编号列表' },
  { Choice: '.ql-list[value="bullet"]', title: '项目列表' },
  { Choice: '.ql-direction', title: '文本方向' },
  { Choice: '.ql-header[value="1"]', title: 'h1' },
  { Choice: '.ql-header[value="2"]', title: 'h2' },
  { Choice: '.ql-align', title: '对齐方式' },
  { Choice: '.ql-color', title: '字体颜色' },
  { Choice: '.ql-background', title: '背景颜色' },
  { Choice: '.ql-image', title: '图像' },
  { Choice: '.ql-video', title: '视频' },
  { Choice: '.ql-link', title: '添加链接' },
  { Choice: '.ql-formula', title: '插入公式' },
  { Choice: '.ql-clean', title: '清除字体格式' },
  { Choice: '.ql-script[value="sub"]', title: '下标' },
  { Choice: '.ql-script[value="super"]', title: '上标' },
  { Choice: '.ql-indent[value="-1"]', title: '向左缩进' },
  { Choice: '.ql-indent[value="+1"]', title: '向右缩进' },
  { Choice: '.ql-header .ql-picker-label', title: '标题大小' },
  { Choice: '.ql-header .ql-picker-item[data-value="1"]', title: '标题一' },
  { Choice: '.ql-header .ql-picker-item[data-value="2"]', title: '标题二' },
  { Choice: '.ql-header .ql-picker-item[data-value="3"]', title: '标题三' },
  { Choice: '.ql-header .ql-picker-item[data-value="4"]', title: '标题四' },
  { Choice: '.ql-header .ql-picker-item[data-value="5"]', title: '标题五' },
  { Choice: '.ql-header .ql-picker-item[data-value="6"]', title: '标题六' },
  { Choice: '.ql-header .ql-picker-item:last-child', title: '标准' },
  { Choice: '.ql-size .ql-picker-item[data-value="small"]', title: '小号' },
  { Choice: '.ql-size .ql-picker-item[data-value="large"]', title: '大号' },
  { Choice: '.ql-size .ql-picker-item[data-value="huge"]', title: '超大号' },
  { Choice: '.ql-size .ql-picker-item:nth-child(2)', title: '标准' },
  { Choice: '.ql-align .ql-picker-item:first-child', title: '居左对齐' },
  {
    Choice: '.ql-align .ql-picker-item[data-value="center"]',
    title: '居中对齐'
  },
  {
    Choice: '.ql-align .ql-picker-item[data-value="right"]',
    title: '居右对齐'
  },
  {
    Choice: '.ql-align .ql-picker-item[data-value="justify"]',
    title: '两端对齐'
  }
]
Quill.register('modules/ImageExtend', ImageExtend)
export default {
  name: 'discountAdd',
  components: { quillEditor, UploadImage },
  data () {
    return {
      radio: '1',
      tableKey: 0,
      form: {
        authorIcon: '', // 作者头像
        authorName: '', // 名称
        content: '',
        cover: '', // 封面图
        isHot: '',
        likeCount: '', // 点赞数量
        status: null, // 状态
        title: null, // 标题
        id: '',
        categoryId: '',
        vipContent: '',
        vipContentEn: 0
      },
      listQuery: {
        isHot: '',
        keyword: '',
        currentPage: 1,
        pageSize: 20,
        categoryId: ''
      },
      isHotList: [
        {
          index: 0,
          name: '否'
        },
        {
          index: 1,
          name: '是'
        }
      ],
      statusList: [
        {
          index: 0,
          name: '下架'
        },
        {
          index: 1,
          name: '上架'
        }
      ],
      rules: {
        authorName: [
          {
            required: true,
            message: '请输入作者名称',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 15,
            message: '长度在 1 到 15 个字符',
            trigger: 'blur'
          }
        ],
        authorIcon: [
          {
            required: true,
            message: '请上传作者头像',
            trigger: 'change'
          }
        ],
        content: [
          {
            required: true,
            message: '请输入文章内容',
            trigger: 'change'
          }
        ],
        cover: [
          {
            required: true,
            message: '请上传封面图',
            trigger: 'change'
          }
        ],
        likeCount: [
          {
            required: true,
            message: '请输入点赞数量',
            trigger: 'blur'
          }
        ],
        status: [
          {
            required: true,
            message: '请选择状态',
            trigger: 'change'
          }
        ],
        title: [
          {
            required: true,
            message: '请输入标题',
            trigger: 'blur'
          }
        ]
      },
      // 七牛上传图片
      uploadUrl: 'https://up-z2.qiniup.com',
      uploadData: { key: '', token: '' },
      content: '',
      // 富文本框参数设置
      editorOption: {
        modules: {
          ImageExtend: {
            loading: true,
            name: 'file',
            //   size: 2,
            action: 'https://up-z2.qiniup.com',
            response: res => {
              return this.https + '/' + res.key
            },
            change: (xhr, formData) => {
              formData.append('token', this.uploadData.token)
              formData.append('key', `upload_pic_${new Date().getTime()}`)
            }
          },
          toolbar: {
            container: container,
            handlers: {
              image: function (value) {
                QuillWatch.emit(this.quill.id)
              }
            }
          }
        }
      },
      hrefs: '',
      hrefsList: []
    }
  },
  computed: {
    ...mapGetters(['elements'])
  },
  created () {
    this.listQuery.currentPage = this.$route.query.currentPage
    this.listQuery.pageSize = this.$route.query.pageSize
    this.listQuery.categoryId = this.$route.query.categoryId
    this.getId = this.$route.query.id
    let title = this.$route.query.title
    if (this.getId) {
      if (title == '修改') {
        getArticleDetail(this.getId).then(res => {
          this.form = res
        })
      } else {

      }
    } else {

    }
  },
  watch: {
    $route (to, from) {
      //   this.getList();
    }
  },
  mounted () {
    let that = this
    getToken({}).then(res => {
      that.uploadData.token = res.token
      that.https = res.domain
    })
    that.initTitle()
  },
  methods: {
    initTitle () {
      document.getElementsByClassName('ql-editor')[0].dataset.placeholder = ''
      for (let item of titleConfig) {
        let tip = document.querySelector('.quill-editor ' + item.Choice)
        if (!tip) continue
        tip.setAttribute('title', item.title)
      }
    },
    selectType (e) {
      this.form.isHot = e
    },
    selectStatus (e) {
      this.form.status = e
    },
    selectShowType (e) {
      this.form.showType = e
    },
    onEditorBlur (quill) {
      console.log('editor blur!', this.form.content, quill)
    },
    onEditorFocus (quill) {
      console.log('editor focus!', this.form.content, quill)
    },
    onEditorReady (quill) {
      console.log('editor ready!', quill)
    },
    // 新增文章内容
    getCreate (ruleForm) {
      let that = this
      this.form.id = this.$route.query.id
      this.form.content = this.form.content.replace(
        /(\<img|\<p|\<blockquote|\undefined|\<br>|re |\<\/pre>|\<li |\<iframe|<a href|\><\/a>|\><\/iframe>)/gi,
        function ($0, $1) {
          return {
            're ': '><pre ',
            '</pre>': '</pre>',
            '<p': '<p style="line-height:30px;"',
            // text-indent:1em;
            // "<img":'<img style="max-width:100%;height:auto;margin:5px 0;display:flex;justify-content:center;text-align:center"',
            '<img': '<img style="width:auto;height:auto;margin:5px 0;display:flex;justify-content:center;text-align:center"',
            '<li': '<li style = "line-height:30px"',
            '<iframe': '<video controls="controls"',
            '<blockquote': '<blockquote style="border-left: 4px solid #ccc;margin-bottom: 5px;margin-top: 5px;padding-left: 16px;"',
            'undefined': '',
            '<br>': '<br>',
            '<a href': `<a style="color:blue;cursor: pointer;" href`,
            '></a>': '/></a>',
            '></iframe>': '/></video>'
          }[$1]
        }
      )
      this.$refs[ruleForm].validate(valid => {
        if (valid) {
          if (this.$route.query.title == '新增') {
            this.form.categoryId = this.$route.query.id
            addArticle(this.form).then(res => {
              that.$notify({
                title: '成功',
                message: '新增成功',
                type: 'success',
                duration: 2000
              })
              // that.$router.push("/demo/inspiration");
              this.$router.push({
                path: '/demo/inspiration',
                query: { activeName: 'second' }
              })
            })
          } else {
            this.form.categoryId = this.$route.query.categoryId
            editArticle(this.$route.query.id, this.form).then(res => {
              that.$notify({
                title: '成功',
                message: '修改成功',
                type: 'success',
                duration: 2000
              })
              // that.$router.push("/demo/inspiration");
              this.$router.push({
                path: '/demo/inspiration',
                query: { activeName: 'second' }
              })
            })
          }
        } else {
          return false
        }
      })
    },
    // 取消
    cancel (formName) {
      this.$router.push('/demo/inspiration')
    },
    tableDbEdit (row, column, cell, event) {
      const that = this
      if (column.label == '排序') {
        event.target.innerHTML = ''
        let cellInput = document.createElement('input')
        cellInput.value = ''
        cellInput.setAttribute('type', 'text')
        cellInput.style.width = '80%'
        // cellInput.style.borderRadius = '10px'
        cell.appendChild(cellInput)
        cellInput.focus()
        cellInput.onblur = function () {
          cell.removeChild(cellInput)
          event.target.innerHTML = cellInput.value
          that.$set(row, 'sort', event.target.innerHTML)
        }
      }
    }
  }
}
</script>
<style scoped>
.footer {
  text-align: center;
  margin-top: 30px;
}
.el-dialog__footer {
  display: flex;
}

.icons {
  font-size: 24px;
  position: absolute;
  top: 45%;
  left: 47%;
  transform: translateX(-50%) translateY(-50%);
  color: red;
  display: none;
}
.imgs:hover .icons {
  transform: scale(0) 0.5;
  display: block;
}
</style>
